import { mergeStyles } from "@fluentui/merge-styles";

export const truncatedPathContainerClass = mergeStyles({
  display: "block",
  overflow: "hidden",
  whiteSpace: "nowrap",
  minWidth: 0,
  flex: "1 1 auto",
});

export const measureTextClass = mergeStyles({
  position: "absolute",
  visibility: "hidden",
  whiteSpace: "nowrap",
  pointerEvents: "none",
  top: 0,
  left: 0,
});
